export default __webpack_public_path__ + "static/media/car-seat 1.8406bca1.svg";